<template>
  <div class="home">
    <HelloWorld
      v-if="
        (moduleName == 'AmrPortal' &&
          $router.currentRoute.value.name !== 'error') ||
        $router.currentRoute.value.path == '/' + $realm
      "
      :msg="welcomeMsg"
      style="text-align: center"
    />
    <ErrorVue
      v-if="
        moduleName == 'AmrPortal' && $router.currentRoute.value.name == 'error'
      "
      :code="$route.params.code"
    />
    <RootElement
      v-for="(el, index) in rootEls"
      v-show="moduleName == el.id"
      :key="index"
      :elementAttributes="el"
      :route="route"
      :entryPoint="el.entryPoint"
      :activeModule="moduleName"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import RootElement from "@/components/RootElement.vue";
import ErrorVue from "@/components/ErrorComponent.vue";

export default {
  name: "HomeView",
  inject: ["rootElements"],
  components: {
    HelloWorld,
    RootElement,
    ErrorVue,
  },
  props: {
    errorCode: {
      type: Number,
      default: 500,
    },
    route: {
      type: String,
      default: "",
    },
    moduleName: {
      type: String,
      default: "AmrPortal",
    },
  },
  data() {
    return {
      rootEls: this.rootElements,
    };
  },
  computed: {
    welcomeMsg() {
      if (this.$router) {
        return this.$router.currentRoute.value.name == "loading"
          ? this.$t("messages.loadingModules") + "..."
          : this.$t("messages.homePage");
      } else {
        return this.$t("messages.homePage");
      }
    },
  },
  watch: {
    route(newVal) {
      if ((!newVal || newVal.length == 0) && !this.errorCode == 99999) {
        this.$router.push({
          name: "amrHome",
        });
      }
    },
    rootElements(newVal) {
      this.rootEls = newVal;
    },
  },
  mounted() {
    this.latestRoute = localStorage.getItem("latest_visitied");
    if (this.$props.route.length === 0 && this.latestRoute.endsWith("/home")) {
      const url = window.location.origin + "/" + this.$realm + "/home";
      setTimeout(() => {
        window.history.pushState({}, "", url);
      }, 1000);
    }
  },
};
</script>
